import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
    compact?: boolean
}

export const LogoMark: FC<{ className?: string }> = ({ className }): ReactNode => (
    <svg viewBox='0 0 64 64' aria-hidden='true' className={cn('size-8 shrink-0', className)}>
        <rect width='64' height='64' rx='16' className='fill-primary' />
        <g fill='none' stroke='#fff' strokeWidth='4.5' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M14 23v-9h9M41 14h9v9M50 41v9h-9M23 50h-9v-9' />
            <path d='M23 41V32l9-7 9 7v9z' />
        </g>
    </svg>
)

export const Logo: FC<LogoProps> = ({ className, compact = false }): ReactNode => (
    <Link
        href='/'
        className={cn('flex shrink-0 items-center gap-2 rounded-lg focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary', className)}
        aria-label='Viewfinder Realty home'
    >
        <LogoMark />

        <span className={cn('text-[1.35rem] font-extrabold tracking-tight text-primary', compact && 'hidden lg:inline')}>
            viewfinder
        </span>
    </Link>
)
